var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "error" }, [
    _c(
      "div",
      { staticClass: "nav" },
      [
        _c("p", [_vm._v(_vm._s(_vm.$t("notFound.notFound")))]),
        _c("span", [_vm._v(_vm._s(_vm.$t("notFound.YMWZD")))]),
        _c(
          "el-button",
          { attrs: { type: "text" }, on: { click: _vm.handleGoback } },
          [_vm._v(_vm._s(_vm.$t("notFound.FHSYY")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }